import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "logo-advisor",
  "use": "logo-advisor-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"logo-advisor\"><path d=\"M35.575 37.781A17.925 17.925 0 0 1 24 42a17.923 17.923 0 0 1-11.574-4.219h23.15zM24 6c9.941 0 18 8.059 18 18 0 3.471-.985 6.712-2.688 9.46H8.689A17.911 17.911 0 0 1 6 24c0-9.941 8.059-18 18-18zm0 12.518a5.4 5.4 0 1 0 0 10.801 5.4 5.4 0 0 0 0-10.801z\" fill=\"#031425\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol